(function () {
  function initConcierge(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var panel = root.querySelector('.cx-concierge__panel');
    var views = root.querySelectorAll('[data-cx-concierge-view]');
    var closeButtons = root.querySelectorAll('[data-cx-concierge-close]');
    var openButtons = document.querySelectorAll('[data-cx-concierge-open]');
    var sampleOptions = root.querySelectorAll('[data-cx-sample-option]');
    var sampleSubmit = root.querySelector('[data-cx-samples-submit]');
    var sampleCount = root.querySelector('[data-cx-sample-count]');
    var sampleTotal = root.querySelector('[data-cx-sample-total]');
    var sampleStatus = root.querySelector('[data-cx-sample-status]');
    var sampleSearch = root.querySelector('[data-cx-sample-search]');
    var sampleNoResults = root.querySelector('[data-cx-sample-no-results]');
    var variantId = root.dataset.sampleVariantId;
    var selected = [];
    var lastTrigger = null;

    function setStatus(message, isError) {
      if (!sampleStatus) return;
      sampleStatus.textContent = message || '';
      sampleStatus.hidden = !message;
      sampleStatus.dataset.error = isError ? 'true' : 'false';
    }

    function updateSummary() {
      var quantity = selected.length;
      if (sampleCount) sampleCount.textContent = quantity + (quantity === 1 ? ' muestra' : ' muestras');
      if (sampleTotal) sampleTotal.textContent = 'USD ' + (quantity * 5) + ' + IVA';
      if (sampleSubmit) {
        sampleSubmit.disabled = quantity === 0 || !variantId;
        sampleSubmit.querySelector('span').textContent = variantId
          ? (quantity ? 'Agregar al carrito' : 'Seleccioná tus muestras')
          : 'Producto de muestras pendiente';
      }
    }

    function showView(name) {
      views.forEach(function (view) {
        view.hidden = view.dataset.cxConciergeView !== name;
      });
    }

    function open(name, trigger) {
      lastTrigger = trigger || null;
      showView(name || 'visit');
      root.hidden = false;
      document.body.classList.add('cx-concierge-open');
      window.requestAnimationFrame(function () {
        var focusTarget = panel.querySelector('[data-cx-concierge-view]:not([hidden]) input, [data-cx-concierge-view]:not([hidden]) button');
        if (focusTarget) focusTarget.focus();
      });
    }

    function close() {
      root.hidden = true;
      document.body.classList.remove('cx-concierge-open');
      if (lastTrigger) lastTrigger.focus();
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        open(button.dataset.cxConciergeOpen, button);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) close();
    });

    sampleOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        var code = option.dataset.sampleCode;
        var active = option.getAttribute('aria-pressed') === 'true';

        setStatus('');
        if (!active && selected.length >= 3) {
          setStatus('Podés elegir hasta 3 muestras por solicitud.', true);
          return;
        }

        option.setAttribute('aria-pressed', active ? 'false' : 'true');
        if (active) {
          selected = selected.filter(function (item) { return item.code !== code; });
        } else {
          selected.push({
            code: code,
            title: option.dataset.sampleTitle
          });
        }
        updateSummary();
      });
    });

    if (sampleSearch) {
      sampleSearch.addEventListener('input', function () {
        var query = sampleSearch.value.trim().toLocaleLowerCase('es');
        var visible = 0;

        sampleOptions.forEach(function (option) {
          var haystack = (option.dataset.sampleTitle + ' ' + option.dataset.sampleCode).toLocaleLowerCase('es');
          var matches = !query || haystack.indexOf(query) !== -1;
          option.hidden = !matches;
          if (matches) visible += 1;
        });

        if (sampleNoResults) sampleNoResults.hidden = visible !== 0;
      });
    }

    if (sampleSubmit) {
      sampleSubmit.addEventListener('click', function () {
        if (!variantId || selected.length === 0 || sampleSubmit.disabled) return;
        sampleSubmit.disabled = true;
        sampleSubmit.querySelector('span').textContent = 'Agregando…';
        setStatus('');

        var items = selected.map(function (sample) {
          return {
            id: Number(variantId),
            quantity: 1,
            properties: {
              'Muestra': sample.title,
              'Código': sample.code,
              'Crédito bonificable': 'USD 5 + IVA',
              'Vigencia del crédito': '90 días'
            }
          };
        });

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('No pudimos agregar las muestras.');
            return response.json();
          })
          .then(function () {
            window.location.assign(window.Shopify.routes.root + 'cart');
          })
          .catch(function () {
            setStatus('No pudimos agregar las muestras. Probá nuevamente o escribinos por WhatsApp.', true);
            updateSummary();
          });
      });
    }

    updateSummary();
  }

  function boot() {
    document.querySelectorAll('[data-cx-concierge]').forEach(initConcierge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
